<template>
  <div>
    <div class="q-mb-5 q-bg-white get-the-look__stylisation-image" v-if="stylization">
      <img v-lazy="stylization.image_link" :alt="stylization.title" class="q-img-fluid">
      <p v-if="getStylisationProduct.description" class="q-row q-p-3 q-bg-white get-the-look__stylisation-description">
        {{ getStylisationProduct.description }}
      </p>
    </div>
    <NoStylisationInfo :show-alert="!stylization && !getStylisationLoading"/>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'
import { useStylisationStore } from '@/store/stylisationStore'
import { storeToRefs } from 'pinia/dist/pinia'
import NoStylisationInfo from '@/components/NoStylisationInfo'

defineProps(['stylization'])
const stylisationStore = useStylisationStore()

const { getStylisationLoading, getStylisationProduct } = storeToRefs(stylisationStore)

</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>